export const getNumberDisplayWithCommaNFloating = value => {
    if (value === undefined || value === null || value === '') {
      return '-';
    }
  
    return (parseFloat(value).toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };